import {
  FormPropertySlice,
  useResetFormPropertyState
} from "./slices/FormPropertySlice";
import buildingToolsSlice, {
  useResetBuildingToolsState
} from "./slices/BuildingTools";
import { SeoFormSlice, useResetSeoFormState } from "./slices/SeoFormSlice";

import propertyFormFeaturesSlice, {
  useResetFormFeaturesState
} from "./slices/FormFeaturesSlice";
import {
  FormValidationsDocumentsMsgSlice,
  useResetFormValidationDocMsgs
} from "./slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";

// Configure the store
const propertyFormReducer = {
  reducer: {
    [FormPropertySlice.name]: FormPropertySlice.reducer,
    [buildingToolsSlice.name]: buildingToolsSlice.reducer,
    [SeoFormSlice.name]: SeoFormSlice.reducer,
    [propertyFormFeaturesSlice.name]: propertyFormFeaturesSlice.reducer,
    [FormValidationsDocumentsMsgSlice.name]: FormValidationsDocumentsMsgSlice.reducer
  }
};

export const useResetAllFormStates = () => {
  const resetFormPropertyState = useResetFormPropertyState();
  const resetBuildingToolsState = useResetBuildingToolsState();
  const resetSeoFormState = useResetSeoFormState();
  const resetFormFeaturesState = useResetFormFeaturesState();
  const resetFormValidationDocMsgs = useResetFormValidationDocMsgs();

  return () => {
    resetFormPropertyState();
    resetBuildingToolsState();
    resetSeoFormState();
    resetFormFeaturesState();
    resetFormValidationDocMsgs();
  };
};

export default propertyFormReducer;
